import t from '@rcm/i18n-client';
import React, { ChangeEvent, useCallback } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { selectShippingCity, setShippingCity } from '../../slices/shipping';

const ShippingCityByNameField = () => {
    const dispatch = useDispatch();
    const city = useSelector(selectShippingCity);

    const handleChangeCityByName = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        dispatch(setShippingCity(e.target.value));
    }, []);

    return (
        <Row className="mb-3">
            <Form.Group as={Col}>
                <Form.Label>{t('City')}</Form.Label>
                <Form.Control
                    onChange={handleChangeCityByName}
                    value={city}
                />
            </Form.Group>
        </Row>
    );
}

export default ShippingCityByNameField;
